module.exports = __webpack_public_path__ + "img/Profil-PV.fd401325.png";